// src/components/Dashboard/StatCard.jsx
import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

const StatCard = ({ title, value, icon: Icon, color, change }) => {
  // Mapear cores para classes específicas do Tailwind
  const getColorClasses = (colorName) => {
    const colorMap = {
      red: {
        bgClass: "bg-red-100",
        textClass: "text-red-600",
      },
      green: {
        bgClass: "bg-green-100",
        textClass: "text-green-600",
      },
      blue: {
        bgClass: "bg-blue-100",
        textClass: "text-blue-600",
      },
      yellow: {
        bgClass: "bg-yellow-100",
        textClass: "text-yellow-600",
      },
      purple: {
        bgClass: "bg-purple-100",
        textClass: "text-purple-600",
      },
      orange: {
        bgClass: "bg-orange-100",
        textClass: "text-orange-600",
      },
    };

    return (
      colorMap[colorName] || {
        bgClass: "bg-gray-100",
        textClass: "text-gray-600",
      }
    );
  };

  const { bgClass, textClass } = getColorClasses(color);

  return (
    <div className="bg-white rounded-xl shadow-sm p-4">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-gray-500 text-xs sm:text-sm">{title}</p>
          <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mt-1 sm:mt-2">
            {value}
          </h3>
          {change && (
            <div
              className={`flex items-center mt-1 sm:mt-2 ${
                change >= 0 ? "text-green-500" : "text-red-500"
              }`}
            >
              {change >= 0 ? (
                <ArrowUpRight size={16} />
              ) : (
                <ArrowDownRight size={16} />
              )}
              <span className="text-xs sm:text-sm ml-1">
                {Math.abs(change)}%
              </span>
            </div>
          )}
        </div>
        <div className={`p-2 sm:p-3 rounded-lg ${bgClass}`}>
          <Icon className={`${textClass} w-4 h-4 sm:w-5 sm:h-5`} />
        </div>
      </div>
    </div>
  );
};

export default StatCard;
